/* eslint-disable no-script-url */
import { FAQ, FooterMenuExclusionList, LogoFooter, TERM_AND_CONDITION } from 'common/constants'
import { MultiLanguageCode } from 'common/languageCodes'
import { NavLink } from 'components/Share/Link'
import parse from 'html-react-parser'
import _ from 'lodash'
import { Col, Container, Row } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { useGlobalStore } from 'store/useGlobalStore'
import { handlePortalMenuItemClick } from 'utils/menuUtils'
import shallow from 'zustand/shallow'
import {
  LayoutLeftFooterContainer,
  SeperatorFAQMenu,
  StyledFooter,
  StyledFooterLogo,
  StyledFooterRow,
  StyledLogoContainer,
  StyledMainNavItem,
  StyledNavItem,
  StyledSubNavSmallScreen,
  LogoutFooterListItem
} from './Footer.styled'

export const Footer = () => {
  const [{ Menu: menu, IsSSO: isSSO }, getLocalText, assetFolder] = useGlobalStore(
    (state) => [state.userClaims, state.getLocalText, state.userClaims.CurrentBuyerTypeAssetFolder],
    shallow
  )
  const intl = useIntl()
  return (
    <StyledFooter assetFolder={assetFolder}>
      <Row>
        <Col md={9} className="d-none d-md-block">
          <nav id="nav-footer" className="nav footer-nav  d-print-none">
            <ul className="nav-list active w-100 justify-content-end">
              {menu?.Children.filter(
                (item) => item.IsWebMenu && (item.Children.length > 0 || item.URL !== 'javascript:')
              ).map((item) => (
                <StyledMainNavItem key={item.MenuItem.Name} assetFolder={assetFolder}>
                  <StyledNavItem href={item.URL === 'javascript:' ? null : item.URL}>
                    {item.MenuItem.Text}
                  </StyledNavItem>
                  {item.Children && (
                    <ul className="subnav">
                      {item.Children.filter((c) => !FooterMenuExclusionList.includes(c.MenuItem.Name)).map(
                        (childItem) => (
                          <li key={childItem.MenuItem.Name}>
                            <NavLink to={childItem.URL} onClick={() => handlePortalMenuItemClick(childItem)}>
                              {childItem.MenuItem.Text}
                            </NavLink>
                          </li>
                        )
                      )}
                    </ul>
                  )}
                </StyledMainNavItem>
              ))}
            </ul>
          </nav>
        </Col>
        <Col md={{ span: 3 }} className="d-none d-md-block">
          <StyledMainNavItem className="more-section">
            <ul className="subnav ">
              <li>
                <NavLink to="/public#terms">{TERM_AND_CONDITION}</NavLink>
              </li>
              <li>
                <NavLink to="/public#privacy">
                  {parse(intl.formatMessage({ id: MultiLanguageCode.PRIVACY_POLICY_HEADER }))}
                </NavLink>
              </li>
              <li>
                <NavLink to="/public#contactUs">
                  {parse(intl.formatMessage({ id: MultiLanguageCode.CONTACT_US }))}
                </NavLink>
              </li>
              <li>
                <NavLink to="/faqs">{FAQ}</NavLink>
              </li>

              {!_.isNil(isSSO) && !isSSO && (
                <>
                  <SeperatorFAQMenu />
                  <LogoutFooterListItem>
                    <NavLink to="/logout">{getLocalText && getLocalText('LOGOUT', 'Logout')}</NavLink>
                  </LogoutFooterListItem>
                </>
              )}
              <li>
                <StyledFooterLogo assetFolder={assetFolder}>
                  <img src={LogoFooter} alt="" />
                </StyledFooterLogo>
              </li>
            </ul>
          </StyledMainNavItem>
        </Col>
        <Col className="d-md-none" xs={12}>
          <StyledSubNavSmallScreen>
            <ul className="subnav">
              <li>
                <NavLink to="/public#terms">{TERM_AND_CONDITION}</NavLink>
              </li>
              <li>
                <NavLink to="/faqs">FAQs</NavLink>
              </li>
              <li>
                <NavLink to="/public#contactUs">
                  {parse(intl.formatMessage({ id: MultiLanguageCode.CONTACT_US }))}
                </NavLink>
              </li>
              {!_.isNil(isSSO) && !isSSO && (
                <LogoutFooterListItem>
                  <NavLink to="/logout">{getLocalText && getLocalText('LOGOUT', 'Logout')}</NavLink>
                </LogoutFooterListItem>
              )}
            </ul>
          </StyledSubNavSmallScreen>
        </Col>
      </Row>
      <Container>
        <StyledFooterRow>
          <LayoutLeftFooterContainer xs md={9}></LayoutLeftFooterContainer>
          <StyledLogoContainer xs md={3} className="d-md-none logo-container">
            <nav id="sub-nav-footer" className="nav footer-nav footer-sub-nav d-print-none"></nav>
            <StyledFooterLogo assetFolder={assetFolder}>
              <img src={LogoFooter} alt="" />
            </StyledFooterLogo>
          </StyledLogoContainer>
        </StyledFooterRow>
      </Container>
    </StyledFooter>
  )
}
